<div class="summary-details-container" *ngIf="summary && summary.sessionSummaries && summary.sessionSummaries.length > 0">

  <div class="timeline-wrapper">

    <ng-container *ngFor="let session of summary.sessionSummaries; let sessionIdx = index; let isLast = last">

      <!-- Session container -->
      <div class="session-item">

        <div class="timeline-marker" [class.is-recent]="sessionIdx === 0"></div>
        <div class="timeline-connector"
             *ngIf="!isLast"
             [class.is-recent]="sessionIdx === 0"></div>

      <div class="session-content">

        <div class="session-header-card"
             (click)="toggleSessionExpansion(session.sessionId)"
             [class.expanded]="isSessionExpanded(session.sessionId)"
             role="button"
             tabindex="0"
             (keydown.enter)="toggleSessionExpansion(session.sessionId)"
             (keydown.space)="toggleSessionExpansion(session.sessionId); $event.preventDefault()">
          <div class="header-top">
            <span class="timestamp">{{ session.lastUpdated | tzAbbr:timezone:'comma' }}</span>
            <app-euds-tag
              *ngIf="sessionIdx === 0"
              class="tag-most-recent"
              label="Most Recent">
            </app-euds-tag>
          </div>
          <h3 class="session-title">{{ getSessionSummaryText(session) }}</h3>
          <div class="session-meta">
            <span class="meta-item">Product: {{ session.product || 'Unknown' }}</span>
            <span class="meta-divider">|</span>
            <span class="meta-item">Step: {{ session.step || 'Unknown' }}</span>
            <span class="meta-divider">|</span>
            <span class="meta-item with-icon">
              <app-euds-svg [icon]="getChannelIcon(session.sourceChannel)" size="sm"></app-euds-svg>
              {{ session.sourceChannel || 'Unknown' }}
            </span>
            <span class="meta-divider">|</span>
            <span class="meta-item reactions">
              <span class="reaction up" [attr.title]="getUpvoteTooltip(session)">
                <app-euds-svg icon="feather/thumbs-up" size="sm"></app-euds-svg>
                <span class="count">{{ getUpvoteCount(session) }}</span>
              </span>
              <span class="reaction down" [attr.title]="getDownvoteTooltip(session)">
                <app-euds-svg icon="feather/thumbs-down" size="sm"></app-euds-svg>
                <span class="count">{{ getDownvoteCount(session) }}</span>
              </span>
            </span>
          </div>
        </div>


        <div class="touchpoints-section" *ngIf="isSessionExpanded(session.sessionId)">
          <h4 class="touchpoints-heading">Touchpoints</h4>

          <!-- Loading state -->
          <div class="tp-loading" *ngIf="sessionLoading[session.sessionId]">
            Loading touchpoint details...
          </div>

          <div class="touchpoint-list" *ngIf="!sessionLoading[session.sessionId]">
            <ng-container *ngFor="let touchpointId of getSessionTouchpointIds(session)">
              <div class="touchpoint-item">
                <span class="touchpoint-timestamp">
                  {{ getTouchpointTimestamp(session.sessionId, touchpointId) | tzAbbr:timezone:'comma' }}
                </span>
                <div class="touchpoint-content">
                  <a
                    class="touchpoint-id-link"
                    (click)="navigateToTouchpoint(touchpointId); $event.stopPropagation()"
                    [attr.aria-label]="'View touchpoint ' + touchpointId"
                    tabindex="0"
                    role="button">
                    ID: {{ touchpointId }}
                  </a>
                  <div class="touchpoint-details">
                    <span class="detail-row">Type: {{ getIndividualTouchpointType(session.sessionId, touchpointId) }}</span>
                    <span class="detail-row">resultCode: {{ getIndividualResultCode(session.sessionId, touchpointId) }}</span>
                    <span class="detail-row">Status: {{ getIndividualTouchpointStatus(session.sessionId, touchpointId) }}</span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- View More / View Less button -->
          <div class="view-more-container"
               *ngIf="hasMoreThanFourTouchpoints(session.sessionId)"
               (click)="$event.stopPropagation()">
            <app-euds-button
              type="secondary"
              [label]="showAllTouchpoints[session.sessionId] ? 'View Less' : 'View More'"
              (clickEvent)="toggleViewMore(session.sessionId)">
            </app-euds-button>
          </div>
        </div>

      </div>
    </div>

    </ng-container>

  </div>

</div>

<div *ngIf="!summary || !summary.sessionSummaries || summary.sessionSummaries.length === 0" class="no-data">
  <p>No touchpoint details available.</p>
</div>
